import React, { useState, useEffect } from "react";

import Axios from 'axios';

import './../PopUp.css';
import './Confirmation.css';

import env from "../../../services/Env";
import { ListDataPage } from "../../../services/UpdateData";

import { SetStatusGlobal } from "../../../interface/Global";
import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

import { Svg_Close } from "../../Svg";
import { log } from "console";

interface ConfirmationData {
    origin: string;
    title: string;
    type: string;
    id: string | number;
    name: string;
    status: string;
}

interface ListDataResponse {
    status_data: boolean;
    data: any;
}

export default function PopUp_Confirmation() {

    const [ modalData, setModaldata ] = useState<ConfirmationData>({} as ConfirmationData);
    const [ showPopUp, setShowPopUp ] = useState(false);
    
    function ClosePopUp(){
        SetModalState('Confirmation', false);
    }
    
    function CloseLoading(){
        setTimeout(() => {
            SetStatusGlobal('loading', false);
        }, 200);
    }

    async function AltStatus(){
        SetStatusGlobal('loading', true);        
        try {
            const response = await Axios.post<ListDataResponse>(env.apiUrl, {
                type_page: modalData.origin,
                type_data: modalData.type,
                id: Number(modalData.id),
                status: Number(modalData.status),
                token: localStorage.getItem('token')
            });

            if(response.data.status_data){
                ListDataPage();
                ClosePopUp();

            }else {
                console.log("Error updating status");
            }

            CloseLoading();
        }catch (error) {
            console.error('Error fetching data:', error);
            CloseLoading();
        }
    }
    
    useEffect(()=>{
        RegisterModalData('Confirmation', setModaldata);
        RegisterModalObserver('Confirmation', setShowPopUp);
    }, []);

    useEffect(()=>{
        if(showPopUp){
            setModaldata(modalData);
        }
    }, [showPopUp]);

    return(
        (showPopUp ?
            <div className="PopUp PopUpCenter">
                <div className="all Confirmation">
                    <div className="div_title">
                        <div className="">{ modalData.title }</div>
                        <div className="close" onClick={ ClosePopUp }>
                            <Svg_Close className="icons" color="#B1B2B2" />
                        </div>
                    </div>
                    <div className="div_data">
                        <div className="inf_alt">
                            { modalData.name }
                        </div>

                        <div className="div_btn">
                            <div className="btn not" onClick={ ClosePopUp }>
                                Not
                            </div>
                            <div className="btn yes" onClick={ AltStatus }>
                                Yes
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        : <React.Fragment></React.Fragment>)
    )
}